import { GithubEntwurf } from '../types';

/**
 * Reiner Zustandsübergang der Ticket-Entwurfskarte nach erfolgreicher Server-Antwort.
 * Anlegen -> ANGELEGT (+ issue_url), Verwerfen -> VERWORFEN. Der Eingabe-Entwurf bleibt unverändert.
 */
export function naechsterZustand(
  e: GithubEntwurf,
  antwort: { issue_url?: string },
  aktion: 'anlegen' | 'verwerfen',
): GithubEntwurf {
  if (aktion === 'anlegen') {
    return { ...e, status: 'ANGELEGT', issue_url: antwort.issue_url };
  }
  return { ...e, status: 'VERWORFEN' };
}

/** Issue-Nummer aus der GitHub-Issue-URL (…/issues/12 -> 12); null, wenn nicht erkennbar. */
export function issueNummerAusUrl(url?: string): number | null {
  const m = url?.match(/\/issues\/(\d+)(?:[/?#]|$)/);
  return m ? Number(m[1]) : null;
}
